import { render, staticRenderFns } from "./IndexNumber.vue?vue&type=template&id=44744c2b&"
import script from "./IndexNumber.vue?vue&type=script&lang=js&"
export * from "./IndexNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports